import {
  ComplianceFixId,
  complianceFixForTitle,
  type ActionTarget,
  type ComplianceFix,
  type ComplianceScope,
} from '@bartizo/shared';

/**
 * What the Compliance page offers to apply (P11.19): from the failing checks it
 * lists, the ones Bartizo has a fix for, once each, and the servers they are for.
 */

export interface FixChoice {
  id: ComplianceFixId;
  title: string;
  does: string;
  /** How many of the page's failing checks this fix answers. */
  checks: number;
}

/** The fixes among a page's failing checks that Bartizo can make, once each. */
export function fixChoices(fixes: readonly ComplianceFix[]): FixChoice[] {
  const byId = new Map<ComplianceFixId, FixChoice>();
  for (const fix of fixes) {
    const known = complianceFixForTitle(fix.title);
    const id = ComplianceFixId.safeParse(known?.id);
    if (known === undefined || !id.success) continue;
    const seen = byId.get(id.data);
    if (seen === undefined) {
      byId.set(id.data, { id: id.data, title: fix.title, does: known.does, checks: 1 });
    } else {
      seen.checks += 1;
    }
  }
  return [...byId.values()];
}

/** Which servers the page is about, as an action's target. */
export function targetOf(scope: ComplianceScope): ActionTarget {
  if (scope.server !== undefined) return { kind: 'server', id: scope.server };
  if (scope.group !== undefined) return { kind: 'group', id: scope.group };
  return { kind: 'all' };
}
